import { EPrescriptionItemTypeEnum } from '../enum/sukl/e-prescription.item-type-enum';

export const E_PRESCRIPTION_DIAGNOSIS_MAX_LENGTH = 5;

export function normalizeEPrescriptionDiagnosis(value: string | null | undefined): string | null {
    return value?.trim().toUpperCase() || null;
}

export function isEPrescriptionDiagnosisRequired(itemType: string | null, containsCannabis: boolean): boolean {
    return itemType === EPrescriptionItemTypeEnum.MAGISTRALITER && containsCannabis;
}

export function getEPrescriptionDiagnosisError(value: string | null | undefined, required: boolean) {
    const diagnosis = normalizeEPrescriptionDiagnosis(value);
    if (required && !diagnosis) return { kind: 'required' };
    if (diagnosis && diagnosis.length > E_PRESCRIPTION_DIAGNOSIS_MAX_LENGTH) {
        return {
            kind: 'maxLength',
            requiredLength: E_PRESCRIPTION_DIAGNOSIS_MAX_LENGTH,
            actualLength: diagnosis.length,
        };
    }
    return null;
}
